<template>
	<div id="ConnectingToServer" class="fullscreen-centered absolute-top dark-stars">
		<div>
			<Logo/>
			<div class="loading-message loading-dots">Connecting to Mothership</div>
		</div>
	</div>
</template>

<script>
	import Logo from "./Logo.vue";

	export default {
		name: 'ConnectingToServer',
		components: {
			Logo
		},
	}
</script>

<style>
	#ConnectingToServer .loading-message { animation: pulse 1.65s infinite linear; white-space: nowrap; }
</style>